/** Biglietto da visita (vCard 3.0) con nome, azienda e numero WhatsApp. */
function esc(v: string): string {
  return v.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/([,;])/g, '\\$1');
}

export function buildVcard(name: string, phone: string, waDigits: string, organization?: string): string {
  const full = (name || '').trim() || phone;
  const parts = full.split(/\s+/);
  const first = parts.length > 1 ? parts.slice(0, -1).join(' ') : full;
  const last = parts.length > 1 ? parts[parts.length - 1] : '';
  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${esc(last)};${esc(first)};;;`,
    `FN:${esc(full)}`,
    ...(organization ? [`ORG:${esc(organization)};`] : []),
    `TEL;type=CELL;type=VOICE;waid=${waDigits}:${phone}`,
    'END:VCARD',
  ].join('\n');
}
